import * as React from 'react';

import CustomSetup32 from './CustomSetup32';

export const customSetup32 = () => <CustomSetup32 />;

export default {
    title: 'Icon/Content/CustomSetup32',
    component: CustomSetup32,
    parameters: {
        notes: "`import CustomSetup32 from 'box-ui-elements/es/icon/content/CustomSetup32';`",
    },
};
